import React from "react";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStats";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import withAuth from "../../../Hoc/withAuth";
import DrawerListItem from "../Components/DrawerListItem";
import SectionLabel from "../Components/SectionLabel";
import GlobalDrawerItems from "./GlobalDrawerItems";

const StudentDrawer = ({ user }) => {
  const school = user?.SchoolStudent;
  const schoolUuid =
    school?.approved === true ? school?.Org?.uuid : undefined;

  return (
    <div>
      <SectionLabel>Overview</SectionLabel>
      <DrawerListItem
        name="Dashboard"
        path="StudentDashBoard"
        Icon={DashboardOutlinedIcon}
      />

      {schoolUuid && (
        <>
          <SectionLabel>My School</SectionLabel>
          <DrawerListItem
            name="Notice Board"
            path={`mySchool/${schoolUuid}`}
            Icon={CampaignOutlinedIcon}
          />
        </>
      )}

      <SectionLabel>Discover</SectionLabel>
      <GlobalDrawerItems />

      <SectionLabel>Personal</SectionLabel>
      <DrawerListItem
        name="Bookings"
        path="StudentBookings"
        Icon={DateRangeOutlinedIcon}
      />
      <DrawerListItem
        name="Stats"
        path={`StudentStats`}
        Icon={QueryStatsOutlinedIcon}
      />
      <DrawerListItem
        name="Associations"
        path="Associations"
        Icon={PeopleAltOutlinedIcon}
      />
      <DrawerListItem
        name="Rate ChalkItUp"
        path="StudentReview"
        Icon={StarOutlineRoundedIcon}
      />
    </div>
  );
};

export default withAuth(StudentDrawer);
